import React, {MouseEventHandler, useState} from "react";
import {ModalValues} from "../../../../types";
import {ConfirmationModal, OverlayStyle} from "../../../../styles";
import {T2} from "../../../../../../styles/titles";

export const Modal: React.FC<ModalValues> = (props) => {
  const {isShowing, data, onConfirmation} = props;
  const totalItens = Object.keys(data).length

  const handleConfirmation = (event:  React.MouseEvent<HTMLButtonElement>) => {
    const isConfirmed = event.currentTarget.value === '1';

    if (onConfirmation) {
      onConfirmation(isConfirmed);
    }
  }

  console.log(isShowing);

  return (
    <>
      {isShowing && (
        <>
          <OverlayStyle onClick={() => onConfirmation?.(false)} />
          <ConfirmationModal>
            <T2>Confirmação</T2>
            <p>Deseja realmente salvar as alterações em {totalItens} itens?</p>
            <div style={{marginTop: '20px'}}>
              <button
                onClick={handleConfirmation}
                value="0"
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                CANCELAR
              </button>
              <button
                onClick={handleConfirmation}
                value="1"
                style={{
                  marginRight: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                CONFIRMAR
              </button>
            </div>
          </ConfirmationModal>
        </>
      )}
    </>
  )
}
